export default {
  loading: false,
  events: [],
  services: [],
  menus: [],
  openMenu: null,
  defaultRoute: {},
  toggleMenu: false,
  showNotifications: false,
  userCollection: [],
};
